<div class="pp-sidenav" [class.collapsed]="collapsed">
  <div class="sidebar-toggle" (click)="toggleSidebar()">
    <mat-icon>
      <img *ngIf="!collapsed" src="assets/icons/SideNav/collapse-left.svg" class="nav-icon-custom">
      <img *ngIf="collapsed" src="assets/icons/SideNav/collapse-right.svg" class="nav-icon-custom">
    </mat-icon>
  </div>
  <div class="nav-section">

    <!-- Main -->
    <div class="nav-group-label" matTooltip="{{'NAV.SECTION_MAIN' | translate}}">
      <span *ngIf="!collapsed">{{ 'NAV.SECTION_MAIN' | translate }}</span>
    </div>

    <a class="nav-item" [routerLink]="['./initiatives']" [class.active]="isActiveBySource('initiatives')">
      <mat-icon>
        <img src="assets/icons/SideNav/Portfolio.svg" class="nav-icon-custom"
          matTooltip="{{'NAV.PORTFOLIO' | translate}}" [attr.alt]="'NAV.PORTFOLIO' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.PORTFOLIO' | translate}}">{{ 'NAV.PORTFOLIO' | translate }}</span>
    </a>
    <a class="nav-item" [routerLink]="['./portfolio-backlogs']"
      [class.active]="isActiveBySource('portfolio-backlogs')">
      <mat-icon>
        <img src="assets/icons/SideNav/Portfolio-Backlog.svg" class="nav-icon-custom"
          matTooltip="{{'NAV.PORTFOLIO_BACKLOG'| translate}}" [attr.alt]="'NAV.PORTFOLIO_BACKLOG' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.PORTFOLIO_BACKLOG'| translate}}">{{ 'NAV.PORTFOLIO_BACKLOG' |
        translate }}</span>
    </a>

    <a class="nav-item" [routerLink]="['./myportfolio']" [class.active]="isActiveBySource('myportfolio')">
      <mat-icon>
        <img src="assets/icons/SideNav/MyPortfolio.svg" class="nav-icon-custom"
          matTooltip="{{'NAV.MY_PORTFOLIO' | translate}}" [attr.alt]="'NAV.MY_PORTFOLIO' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.MY_PORTFOLIO' | translate}}">{{ 'NAV.MY_PORTFOLIO' | translate
        }}</span>
    </a>
    <a class="nav-item" [routerLink]="['./approvals']" [class.active]="isActiveBySource('approvals')">
      <mat-icon>
        <img src="assets/icons/SideNav/Approval.svg" class="nav-icon-custom"
          matTooltip="{{'NAV.MY_APPROVALS' | translate}}" [attr.alt]="'NAV.MY_APPROVALS' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.MY_APPROVALS' | translate}}">{{ 'NAV.MY_APPROVALS' | translate
        }}</span>
    </a>

    <a class="nav-item" [routerLink]="['./manpower']" [class.active]="isActiveBySource('manpower')">
      <mat-icon>
        <img src="assets/icons/SideNav/manpower.svg" class="nav-icon-custom"
          matTooltip="{{'NAV.PROJECT_JOB_LOG' | translate}}" [attr.alt]="'NAV.PROJECT_JOB_LOG' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.PROJECT_JOB_LOG' | translate}}">{{ 'NAV.PROJECT_JOB_LOG' | translate }}</span>
    </a>

    <!-- OPEX / MEJ -->
    <div class="nav-group-label" matTooltip="{{'NAV.SECTION_OPEX_MEJ' | translate}}">
      <span *ngIf="!collapsed">{{ 'NAV.SECTION_OPEX_MEJ' | translate }}</span>
    </div>

    <a class="nav-item" [routerLink]="['./mybreakinoutapprovals']"
      [class.active]="isActiveBySource('mybreakinoutapprovals')">
      <mat-icon>
        <img src="assets/icons/SideNav/BreakInOut.svg" class="nav-icon-custom"
          matTooltip="{{'NAV.BREAK_IN_OUT_APPROVALS' | translate}}"
          [attr.alt]="'NAV.BREAK_IN_OUT_APPROVALS' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.BREAK_IN_OUT_APPROVALS' | translate}}">{{ 'NAV.BREAK_IN_OUT_APPROVALS'
        | translate }}</span>
    </a>

    <a class="nav-item" [routerLink]="['./newprojectsbreakin']"
      [class.active]="isActiveBySource('newprojectsbreakin')">
      <mat-icon>
        <img src="assets/icons/SideNav/NewProjectsBreakIn.svg" class="nav-icon-custom"
          matTooltip="{{'NAV.NEW_PROJECTS_BREAK_IN' | translate}}"
          [attr.alt]="'NAV.NEW_PROJECTS_BREAK_IN' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.NEW_PROJECTS_BREAK_IN' | translate}}">{{ 'NAV.NEW_PROJECTS_BREAK_IN'
        | translate }}</span>
    </a>

    <a class="nav-item" [routerLink]="['./cutline']" [class.active]="isActiveBySource('cutline')">
      <mat-icon>
        <img src="assets/icons/SideNav/Cutline.svg" class="nav-icon-custom"
          matTooltip="{{'PAGE_TITLES.MEJ_CUT_LINE' | translate}}" [attr.alt]="'NAV.MEJ_CUT_LINE' | translate">

      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'PAGE_TITLES.MEJ_CUT_LINE' | translate}}">{{ 'NAV.MEJ_CUT_LINE' | translate
        }}</span>
    </a>

    <a class="nav-item" [routerLink]="['./forecasts/detail-forecast']" [class.active]="isActiveBySource('forecasts')">
      <mat-icon>
        <img src="assets/icons/PieChart.svg" class="nav-icon-custom" matTooltip="{{'NAV.FORECAST' | translate}}"
          [attr.alt]="'NAV.FORECAST' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.FORECAST' | translate}}">{{ 'NAV.FORECAST' | translate }}</span>
    </a>

    <!-- CAPEX -->
    <div class="nav-group-label" matTooltip="{{'NAV.SECTION_CAPEX' | translate}}">
      <span *ngIf="!collapsed">{{ 'NAV.SECTION_CAPEX' | translate }}</span>
    </div>

    <a class="nav-item" [routerLink]="['./capex/capex-prioritization']" [class.active]="isActiveBySource('capex')">
      <mat-icon>
        <img src="assets/icons/SideNav/capex-prioritization.svg" class="nav-icon-custom" matTooltip="{{'NAV.CAPEX_PRIORITIZATION' | translate}}"
          [attr.alt]="'NAV.CAPEX_PRIORITIZATION' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.CAPEX_PRIORITIZATION' | translate}}">{{ 'NAV.CAPEX_PRIORITIZATION' | translate }}</span>
    </a>

    <!-- Other -->
    <span class="spacer">....</span>

    <a class="nav-item" [routerLink]="['./heatmap']" [class.active]="isActiveBySource('heatmap')">
      <mat-icon>
        <img src="assets/icons/SideNav/Heatmap.svg" class="nav-icon-custom"
          matTooltip="{{'NAV.HEAT_MAP' | translate}}" [attr.alt]="'NAV.HEAT_MAP' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.HEAT_MAP' | translate}}">{{ 'NAV.HEAT_MAP' | translate }}</span>
    </a>

    <a class="nav-item" [routerLink]="['./linked-records']" [class.active]="isActiveBySource('linked-records')">
      <mat-icon>
        <img src="assets/icons/reports-ewr.svg" class="nav-icon-custom-rEwr "
          matTooltip="{{'NAV.REPORTS_EWR' | translate}}" [attr.alt]="'NAV.REPORTS_EWR' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.REPORTS_EWR' | translate}}">{{ 'NAV.REPORTS_EWR' | translate }}</span>
    </a>

    <a *ngIf="canViewDashboard()" class="nav-item" [routerLink]="['./dashboard']"
      [class.active]="isActiveBySource('dashboard')">
      <mat-icon>
        <img src="assets/icons/SideNav/Dashboard.svg" class="nav-icon-custom"
          matTooltip="{{'NAV.DASHBOARD' | translate}}" [attr.alt]="'NAV.DASHBOARD' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.DASHBOARD' | translate}}">{{ 'NAV.DASHBOARD' | translate }}</span>
    </a>

    <!-- <div class="nav-item" [routerLink]="['./settings']" routerLinkActive="active">
      <mat-icon>
        <img src="assets/icons/SolarSettingsLinear.svg" class="nav-icon-custom" alt="Settings">
      </mat-icon>
      <span *ngIf="!collapsed">Settings</span>
    </div> -->
  </div>
  <div class="nav-footer">
    <a mat-button disableRipple [matTooltip]="'NAV.SETTINGS' | translate" class="nav-item"
      [routerLink]="['./settings']" routerLinkActive="active">
      <mat-icon>
        <img src="assets/icons/SolarSettingsLinear.svg" class="nav-icon-custom"
          [attr.alt]="'NAV.SETTINGS' | translate">
      </mat-icon>
      <span *ngIf="!collapsed">{{ 'NAV.SETTINGS' | translate }}</span>
    </a>
    <button mat-button disableRipple class="nav-item" *ngIf="!auth.isSignedIn()" (click)="login()">
      <mat-icon *ngIf="!auth.isSignedIn()">
        <img src="assets/icons/SideNav/login.svg" class="nav-icon-custom" matTooltip="{{'NAV.LOGIN' | translate}}"
          [attr.alt]="'NAV.LOGIN' | translate">
      </mat-icon>
      <span *ngIf="!collapsed" matTooltip="{{'NAV.LOGIN' | translate}}">{{ 'NAV.LOGIN' | translate }}</span>
    </button>

    <ng-container *ngIf="auth.isSignedIn()">
      <button mat-button disableRipple class="nav-item" (click)="logout()">
        <mat-icon *ngIf="auth.isSignedIn()">
          <img src="assets/icons/SideNav/logout.svg" class="nav-icon-custom" matTooltip="{{'NAV.LOGOUT' | translate}}"
            [attr.alt]="'NAV.LOGOUT' | translate">
        </mat-icon>
        <span *ngIf="!collapsed" matTooltip="{{'NAV.LOGOUT' | translate}}">{{ 'NAV.LOGOUT' | translate }}</span>
      </button>
    </ng-container>
    <!-- <button mat-button disableRipple matTooltip="About" class="nav-item" [routerLink]="['./about']" routerLinkActive="active">
      <mat-icon>
        <img src="assets/icons/SideNav/About.svg" class="nav-icon-custom" alt="About">
      </mat-icon>
      <span *ngIf="!collapsed">About</span>
    </button> -->
    <div class="user-info" matTooltip="{{ currentUser?.name  }} {{ currentUser?.email}}">
      <div class="user-avatar">
        {{ getUserInitials() }}
      </div>
      <div class="user-details" *ngIf="!collapsed">
        <div class="user-name">{{ currentUser?.name || ('NAV.USER_NAME_FALLBACK' | translate) }}</div>
        <div class="user-email">{{ currentUser?.email || ('NAV.USER_EMAIL_FALLBACK' | translate) }}</div>
      </div>
    </div>
  </div>
</div>
